.gh{border:1px solid #ddd;}